import { Navigate, Outlet, useLocation } from "react-router-dom";
import { SessionGatePanel } from "./SessionGatePanel";
import { useSession } from "./session";

export function RequireAuth() {
  const location = useLocation();
  const { status, error, refreshSession, refreshingSession } = useSession();

  if (status === "checking") {
    return <SessionGatePanel status="checking" />;
  }

  if (status === "unavailable") {
    return (
      <SessionGatePanel
        status="unavailable"
        error={error}
        onRetry={() => refreshSession()}
        retrying={refreshingSession}
      />
    );
  }

  if (status !== "authenticated") {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  return <Outlet />;
}
